import type { PlatformTypeName } from "@multi-chat/shared";

/**
 * Backend-authoritative free-form send gate used by Inbox `sendMessage`.
 * WhatsApp uses CS-window expiry; Facebook/Instagram use `canSendFreeformText`.
 * Composer UI must use the same capability semantics so visual state matches submit.
 */
export function isFreeformOutboundAllowed(input: {
  platformType: PlatformTypeName | null | undefined;
  canSendFreeformText: boolean | null | undefined;
  customerServiceWindowExpiresAt: string | null | undefined;
  nowMs: number;
}): boolean {
  switch (input.platformType) {
    case "FACEBOOK":
    case "INSTAGRAM":
      return input.canSendFreeformText === true;
    case "WHATSAPP": {
      const expiresAt = input.customerServiceWindowExpiresAt ?? null;
      if (!expiresAt) return false;
      const parsed = Date.parse(expiresAt);
      return !Number.isNaN(parsed) && parsed > input.nowMs;
    }
    case null:
    case undefined:
      return false;
    default: {
      const _exhaustive: never = input.platformType;
      return _exhaustive;
    }
  }
}
